import type { UIAnalyticsEvent, AnalyticsEventPayload } from '@atlaskit/analytics-next';
import { type Attributes, fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	createContainer,
	createHook,
	createStore,
	type Action,
} from '@atlassian/react-sweet-state';
import { ADD_FILTER_DROPDOWN } from '../../common/constants.tsx';

type Store = {
	activeKey: string;
};

type Props = {
	activeKey?: string;
	createAnalyticsEvent: (payload: AnalyticsEventPayload) => UIAnalyticsEvent;
	onJourneyStart?: () => Attributes;
};

type Actions = {
	openPopup: (key: string) => Action<Store, Props>;
	closePopup: (key: string) => Action<Store, Props>;
	closeAllPopups: () => Action<Store, Props>;
};

const store = createStore<Store, Actions>({
	initialState: {
		activeKey: '',
	},
	actions: {
		openPopup:
			(key) =>
			({ setState }, { createAnalyticsEvent, onJourneyStart }) => {
				setState({ activeKey: key });
				if (onJourneyStart) {
					const analyticsEvent = createAnalyticsEvent({
						action: 'opened',
						actionSubject: 'dropdown',
					});

					const attributes = onJourneyStart();

					// Only checking if it matches the "More +" dropdown.
					// Not sending the key name directly as it would result in UGC for custom fields
					attributes.isMoreFilters = String(key === ADD_FILTER_DROPDOWN);

					fireUIAnalytics(analyticsEvent, 'refinementBarBasicPicker', attributes);
				}
			},
		closePopup:
			(key) =>
			({ getState, setState }) => {
				const { activeKey } = getState();
				if (key === activeKey) {
					setState({ activeKey: '' });
				}
			},
		closeAllPopups:
			() =>
			({ setState }) => {
				setState({ activeKey: '' });
			},
	},
	name: 'JQLBasic-ActivePopup',
});

export const ActivePopupKeyContainer = createContainer<Store, Actions, Props>(store, {});

export const useActivePopupKey = createHook(store, {
	selector: ({ activeKey }) => activeKey,
});
